var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8468 21.9342C5.86713 21.3624 2 17.1328 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.1565 18.7173 16.7325 15.9135 16.3703C14.2964 16.1614 12.8386 15.9731 12.2619 16.888C11.8674 17.5136 12.2938 18.2938 12.8168 18.8168C13.4703 19.4703 13.4703 20.5297 12.8168 21.1832C12.2938 21.7062 11.5816 22.0186 10.8468 21.9342Z",
    fill: "#f6e6cf",
    stroke: "#703115",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.085 7C11.085 7.82843 10.4134 8.5 9.585 8.5C8.75658 8.5 8.085 7.82843 8.085 7C8.085 6.17157 8.75658 5.5 9.585 5.5C10.4134 5.5 11.085 6.17157 11.085 7Z",
    fill: "#703115"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13.0002C7.32843 13.0002 8 12.3287 8 11.5002C8 10.6718 7.32843 10.0002 6.5 10.0002C5.67157 10.0002 5 10.6718 5 11.5002C5 12.3287 5.67157 13.0002 6.5 13.0002Z",
    fill: "#703115"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.0002C18.3284 13.0002 19 12.3287 19 11.5002C19 10.6718 18.3284 10.0002 17.5 10.0002C16.6716 10.0002 16 10.6718 16 11.5002C16 12.3287 16.6716 13.0002 17.5 13.0002Z",
    fill: "#703115"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.50023C15.3284 8.50023 16 7.82866 16 7.00023C16 6.1718 15.3284 5.50023 14.5 5.50023C13.6716 5.50023 13 6.1718 13 7.00023C13 7.82866 13.6716 8.50023 14.5 8.50023Z",
    fill: "#703115"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalize);
export default __webpack_public_path__ + "static/media/personalize.beb295d50b031ecb4838d10139d0b48d.svg";
export { ForwardRef as ReactComponent };